import React from "react";

const labels = {
  en: { eyebrow: "How to play", previous: "Previous", next: "Next", finish: "Start playing", skip: "Skip tutorial" },
  fa: { eyebrow: "راهنمای بازی", previous: "قبلی", next: "بعدی", finish: "شروع بازی", skip: "رد کردن آموزش" },
};

export default function MainGameTutorial({ tutorial, stepIndex, onAction }) {
  if (!tutorial?.steps?.length) return null;
  const copy = labels[tutorial.language] || labels.en;
  const current = tutorial.steps[Math.min(stepIndex, tutorial.steps.length - 1)];
  const isLast = stepIndex === tutorial.steps.length - 1;

  return (
    <section
      className="pointer-events-auto absolute inset-0 z-20 flex items-center justify-center bg-slate-950/60 p-4 backdrop-blur-[2px] sm:p-8"
      dir={tutorial.direction}
      aria-label={copy.eyebrow}
    >
      <div className="w-full max-w-xl rounded-[2rem] border border-white/20 bg-slate-950/90 p-5 text-center text-white shadow-2xl shadow-black/70 sm:p-8">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-cyan-300/25 bg-gradient-to-br from-violet-500/30 to-cyan-400/20 text-3xl font-black text-cyan-100">
          {current.icon}
        </div>
        <p className="mt-5 text-xs font-black uppercase tracking-[0.22em] text-pink-300">{copy.eyebrow}</p>
        <h2 className="mt-2 text-2xl font-black tracking-tight sm:text-3xl">{current.title}</h2>
        <p className="mx-auto mt-3 max-w-md text-sm leading-7 text-indigo-100/80 sm:text-base">{current.body}</p>

        <div className="mt-6 flex justify-center gap-2" aria-label={`${stepIndex + 1} / ${tutorial.steps.length}`}>
          {tutorial.steps.map((_, index) => (
            <span key={index} className={`h-2 rounded-full transition-all ${index === stepIndex ? "w-8 bg-cyan-300" : "w-2 bg-white/25"}`} />
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <button type="button" onClick={() => onAction("previous")} disabled={stepIndex === 0} className="rounded-xl border border-white/15 px-4 py-2 text-sm font-bold disabled:opacity-35">
            {copy.previous}
          </button>
          <button type="button" onClick={() => onAction("next")} className="rounded-xl bg-gradient-to-r from-violet-500 to-cyan-400 px-5 py-2 text-sm font-black text-slate-950">
            {isLast ? copy.finish : copy.next}
          </button>
          <button type="button" onClick={() => onAction("skip")} className="rounded-xl px-4 py-2 text-sm font-bold text-white/65 hover:text-white">
            {copy.skip}
          </button>
        </div>
      </div>
    </section>
  );
}
